import { withProfiler } from '@do/seashell';
import { BrowserRouter, Navigate, Route, Routes } from '@do/seashell/navigation';
import React, { ReactElement, useEffect, useState } from 'react';
import Login from './components/Login';
import PasswordForgot from './components/PasswordForgot';
import PasswordReset from './components/PasswordReset';
import InterstitialRegistration from './components/Registration';
import SessionExpired from './components/SessionExpired';
import { SiftScriptWrapper } from './components/SiftScript';
import { REGISTER_SHOW_FORM_STEP } from './constants';
import useInitialUrlCleanup from './hooks/use-initial-url-cleanup';
import initializeSegment from './utils/segment-script';

export function App(): ReactElement {
  const [hasInitializedAnalytics, setHasInitializedAnalytics] = useState(false);

  // load the Segment script only once
  useEffect(() => {
    const isInitialized = window.analytics?.initialized;

    if (!hasInitializedAnalytics && !isInitialized) {
      initializeSegment();

      window.analytics.ready(() => {
        setHasInitializedAnalytics(true);
      });
    }
  }, [hasInitializedAnalytics]);

  useInitialUrlCleanup();

  return (
    <BrowserRouter>
      <SiftScriptWrapper />

      <Routes>
        <Route path="/registrations/new" element={<InterstitialRegistration />} />
        <Route path="/registration-next" element={<Navigate to="/registrations/new" replace />} />
        <Route path="/registrations/email" element={<InterstitialRegistration step={REGISTER_SHOW_FORM_STEP} />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot_password/new" element={<PasswordForgot />} />
        <Route path="/password_resets/:token" element={<PasswordReset />} />
        <Route path="/timeout" element={<SessionExpired />} />
      </Routes>
    </BrowserRouter>
  );
}

export default withProfiler(App);
